exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cover-layer{z-index:11;background-color:#333}.cover-layer img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports
